import {useEffect} from 'react';
export const QrNextId = ({id,loopTo,handleNextId}) =>{

	useEffect(()=>{
		const getNumPos =(data)=>{
			return {
				start:data.prefix.length,
				end:data.length-data.postfix.length
			};
		}
		const getNum =(text, numPos)=>{
			return {
				length:numPos.end-numPos.start,
				value:parseInt(text.substring(numPos.start,numPos.end))
			};
		}
		const getPostfix = (text)=>{
			if(text.substring(text.length-1,text.length) === 'R'){
				return 'R';
			}
			return '';
		}
		const getData = (text)=>{
			var data = {
				length:text.length,
				prefix:text.substring(0,2),
				postfix:getPostfix(text),
			};
			data.numPos = getNumPos(data);
			data.num = getNum(text, data.numPos);
			return data;
		}
		const hasNextPrint = (a,b) =>{
			return a.prefix === b.prefix
			&& a.postfix === b.postfix
			&& a.num.value < b.num.value ;
		}
		if(loopTo && (id !== loopTo)){
			var idData = getData(id);
			var LoopToData = getData(loopTo);
			if(hasNextPrint(idData,LoopToData)){
				const newId = idData.prefix + (idData.num.value + 1).toString().padStart(idData.num.length, '0') + idData.postfix;
				handleNextId(newId);
			}
		}
	},[id,loopTo,handleNextId])
  return false;
}
